import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCurrentUser,
  getCategoryInfo,
  resetCategoryInfo,
  toggleChallengers
} from "./redux/revenueCategoriesSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { Info } from "./smartComponents/Info";
import { Upload } from "./smartComponents/Upload";
import { Dialog } from "./smartComponents/Dialog";
import { usePopup } from "./hooks/usePopup";
import FilterCategories from "./smartComponents/FilterCategories";
import { RevenueCategoriesMenu } from "./smartComponents/RevenueCategoriesMenu";
import "./revenueCategories.scss";

export function RevenueCategoriesModule({ params }) {
  const dispatch = useDispatch();
  const { popup, openPopup, closePopup } = usePopup();

  const isLoading = useSelector((state) => state.revenueCategories.isLoading);
  const services = useSelector((state) => state.revenueCategories.revenueCategories.service);
  const products = useSelector((state) => state.revenueCategories.revenueCategories.product);
  const { canEnableChallengers, canToggleTags } = useSelector(
    (state) => state.revenueCategories.actions
  );

  const [selectedCategory, setSelectedCategory] = useState(null);
  //for opening collapsible element
  const [referralId, setReferralId] = useState(null);
  const [showAllItems, setShowAllItems] = useState(false);

  const reset = () => {
    setReferralId(null);
    setShowAllItems(false);
    dispatch(resetCategoryInfo());
  };

  const handleCategory = (id) => {
    if (id === referralId) {
      reset();
    } else {
      setShowAllItems(false);
      setReferralId(id);
      dispatch(getCategoryInfo({ id }));
    }
  };

  const handlePopup = (item, type) => {
    setSelectedCategory(item);
    openPopup(type);
  };

  const onChallengersToggleClick = () => {
    dispatch(
      toggleChallengers({
        rcoId: selectedCategory.rcoId,
        challenger: selectedCategory.challenger
      })
    );
  };

  useEffect(() => {
    dispatch(fetchCurrentUser(params));
  }, []);

  if (isLoading)
    return (
      <div className="light">
        <LoadingAnimation />
      </div>
    );

  const onShowAllClick = (e, isOpened) => {
    e.stopPropagation();
    if (isOpened) {
      setShowAllItems(!showAllItems);
    }
  };

  return (
    <div id="revenue-categories">
      <div className="revenue-categories">
        <div className="revenue-categories__top">
          {/* Add Menu */}
          <div className="revenue-categories__menu">
            <RevenueCategoriesMenu openPopup={openPopup} />
          </div>

          <FilterCategories reset={reset} />
        </div>

        <div className="revenue-categories__content">
          {services && (
            <ul className="group">
              <p className="revenue-categories__title">Services</p>
              {services.map((category) => {
                let { id, name, challenger, count } = category;
                return (
                  <Fragment key={id}>
                    <li color="dark" className="group__item" onClick={() => handleCategory(id)}>
                      <div className="group__el text">
                        {name} ({count} assigned)
                      </div>
                      {canEnableChallengers && (
                        <div
                          className="group__el challenger"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePopup(category, "challengers");
                          }}
                        >
                          <span
                            title={`${challenger ? "Disable" : "Enable"} Challengers Option`}
                            className={`glyphicon glyphicon-copyright-mark ${
                              challenger ? "text-green" : "grey"
                            }`}
                          />
                        </div>
                      )}
                      {canToggleTags && (
                        <div
                          className="group__el showAll"
                          onClick={(e) => onShowAllClick(e, id === referralId)}
                        >
                          <span
                            className={`glyphicon glyphicon-tags ${
                              showAllItems && id === referralId ? "text-green" : "grey"
                            } `}
                          />
                        </div>
                      )}
                    </li>
                    {id === referralId ? (
                      <Info
                        revenueCategoryId={id}
                        showAllItems={showAllItems}
                        canToggleTags={canToggleTags}
                        setShowAllItems={setShowAllItems}
                      />
                    ) : null}
                  </Fragment>
                );
              })}
            </ul>
          )}

          {products && (
            <ul className="group">
              <p className="revenue-categories__title">Products</p>
              {products.map((category) => {
                let { id, name, count } = category;
                return (
                  <Fragment key={id}>
                    <li color="dark" className="group__item" onClick={() => handleCategory(id)}>
                      <div className="group__el text">
                        {name} ({count} assigned)
                      </div>
                    </li>

                    {id === referralId ? (
                      <Info revenueCategoryId={id} canToggleTags={false} />
                    ) : null}
                  </Fragment>
                );
              })}
            </ul>
          )}

          {!products && !services && <p className="error">No data found</p>}
        </div>

        {popup.challengers && (
          <Dialog primaryBtnHandler={onChallengersToggleClick} onClose={closePopup("challengers")}>
            Are you sure to toggle challengers options for
            <br />
            <span className="text-bold">{selectedCategory.name}</span>
          </Dialog>
        )}

        {popup.upload && <Upload onClose={closePopup("upload")} />}
      </div>
    </div>
  );
}
